export default "__VITE_ASSET__DoMnt5r4__"